module.exports = __webpack_public_path__ + "img/Antimicrobial Resistance.ae020a35.jpg";